import { combineReducers, createSlice } from "@reduxjs/toolkit";
import folderReducer from "./foldersReducer";
import assetReducer from "./assetReducer";

const codeSlice = createSlice({
	name: "knowledgeBase/code",
	initialState: {},
	reducers: {
		setKnowledgeBaseConfig: (_, action) => action.payload
	}
});

export const { setKnowledgeBaseConfig } = codeSlice.actions;

export const selectKnowledgeBaseConfig = state => state.knowledgeBase.config;

const knowledgeBaseReducer = combineReducers({
	folder: folderReducer,
	asset: assetReducer,
	config: codeSlice.reducer
});

export default knowledgeBaseReducer;
